//export const API_HOST = 'https://icaps-hanteraservice-dev-cloudrun-kwyk47pogq-ez.a.run.app'; // Replace with your actual host URL
export const API_HOST = 'https://iows.cte.ikeadt.com';
export const REDIRECT_URI = 'https://ces-cte-hantera.ingka.com';
